import { RouteRecordRaw } from "vue-router";
import { UserRoleEnum } from "@/app/core/enums/UserRoleEnum";

export const routePrivateProfile: Array<RouteRecordRaw> = [
  {
    path: "profile",
    name: "ProfileLayout",
    component: () => import("@/app/private/pages/profile/ProfileLayout.vue"),
    meta: {
      requireAuth: true,
      roles: [UserRoleEnum.Shipper, UserRoleEnum.Carrier, UserRoleEnum.Admin, UserRoleEnum.Master],
    },
    children: [
      {
        path: "",
        name: "Profile",
        component: () => import("@/app/private/pages/profile/pages/my-profile/MyProfile.vue"),
      },
      {
        path: "users",
        name: "MyUsers",
        component: () => import("@/app/private/pages/profile/pages/my-users/MyUsers.vue"),
      },
      {
        path: "notifications",
        name: "Notifications",
        component: () =>
          import("@/app/private/pages/profile/pages/notifications/Notifications.vue"),
      },
      {
        path: "saved-equipment",
        name: "SavedEquipment",
        component: () =>
          import("@/app/private/pages/profile/pages/saved-equipment/SavedEquipment.vue"),
      },
      {
        path: "payment-methods",
        name: "PaymentMethods",
        component: () =>
          import("@/app/private/pages/profile/pages/payment-methods/PaymentMethods.vue"),
      },
      {
        path: "notification-settings",
        name: "NotificationSettings",
        component: () =>
          import("@/app/private/pages/profile/pages/notification-settings/NotificationSettings.vue"),
      },
      {
        path: "saved-contacts",
        name: "SavedContacts",
        component: () =>
          import("@/app/private/pages/profile/pages/saved-contacts/SavedContacts.vue"),
      },
    ],
  },
];
